//import * as Bluetooth from 'react-bluetooth';
import * as HelperFunctions from '../common/functions/helperFunctions';

class BluetoothService {


  getValue = (servicesName: string, characteristicName: string, isFloat: boolean = false) => {
    let services: Array<string> = [];
    services.push(servicesName);
    return navigator.bluetooth.requestDevice({ filters: [{ services: services }] })
      .then((device: any) => device.gatt.connect())
      .then(server => {
        console.log('server');
        return server.getPrimaryService(servicesName);
      })
      .then(service => {
        console.log('service');
        return service.getCharacteristic(characteristicName);
      })
      .then(characteristic => {
        console.log('characteristic');
        return characteristic.readValue();
      })
      .then(value => {
        console.log('Value: ' + value);
        value = value.buffer ? value : new DataView(value);
        return isFloat ? value.getFloat32(0) : value.getUint8(0);
      })
      .catch(error => Promise.reject(HelperFunctions.getErrorMessage(error)));
  }

  getCharacteristic = (servicesName: string, characteristicName: string) => {
    let services: Array<string> = [];
    services.push(servicesName);
    return navigator.bluetooth.requestDevice({ filters: [{ services: services }] })
      .then((device: any) => device.gatt.connect())
      .then(server => {
        console.log('server');
        return server.getPrimaryService(servicesName);
      })
      .then(service => {
        console.log('service');
        return service.getCharacteristic(characteristicName);
      })
      .catch(error => Promise.reject(HelperFunctions.getErrorMessage(error)));
  }

  parseHeartRate = (data: any) => {
    let flags = data.getUint8(0);
    let rate16Bits = flags & 0x1;
    let result: any = {};
    let index = 1;

    if (rate16Bits) {
      result.heartRate = data.getUint16(index, /*littleEndian=*/true);
      index += 2;
    } else {
      result.heartRate = data.getUint8(index);
      index += 1;
    }

    let contactDetected = flags & 0x2;
    let contactSensorPresent = flags & 0x4;

    if (contactSensorPresent) {
      result.contactDetected = !!contactDetected;
    }

    let energyPresent = flags & 0x8;

    if (energyPresent) {
      result.energyExpended = data.getUint16(index, /*littleEndian=*/true);
      index += 2;
    }

    let rrIntervalPresent = flags & 0x10;

    if (rrIntervalPresent) {
      let rrIntervals: Array<any> = [];
      for (; index + 1 < data.byteLength; index += 2) {
        rrIntervals.push(data.getUint16(index, /*littleEndian=*/true));
      }
      result.rrIntervals = rrIntervals;
    }

    return result;
  }

  parseTemparature = (data: any) => {
    let flags = data.getUint8(0);
    let isFahrenheit = flags & 0x1;
    let result: any = {};
    let index = 1;

    if (isFahrenheit) {
      result.unit = 'Fahrenheit';
    } else {
      result.unit = 'Celsius';
    }

    result.temperature = data.getFloat32(index, /*littleEndian=*/true);

    return result;
  }



  // getBluetoothDevices = (filter: string) => {
  //   if (filter === 'battery_service') {
  //     console.log('Bluetooth by service: ' + filter);
  //     navigator.bluetooth.requestDevice(
  //       {
  //         filters: [{ services: ['battery_service'] }]
  //       })
  //       .then((device: any) => { /* ... */ })
  //       .catch((error: any) => { console.log(error); });
  //   } else {
  //     console.log('Bluetooth by name: ' + filter);
  //     navigator.bluetooth.requestDevice(
  //       {
  //         filters: [{ name: filter }]
  //       })
  //       .then((device: any) => {
  //         console.log('Bluetooth device: ' + device);
  //       })
  //       .catch((error: any) => {
  //         console.log(error);
  //       });
  //   }
  // }

  // example_GetAnyDeviceAsync = async function () {
  //   const isAvailable = await Bluetooth.getAvailabilityAsync();
  //   if (!isAvailable) {
  //     console.log('Bluetooth is not available.');
  //     return;
  //   }
  //   try {
  //     const device = await Bluetooth.requestDeviceAsync();
  //     console.log('Success: Got any device: ', device);
  //   } catch (error) {
  //     console.log(`Error: Couldn't get any device`, error);
  //     console.error(`Error: Couldn't get any device`, error);
  //   }
  // }

  // example_GetBatteryLevelAsync = async function () {
  //   const isAvailable = await Bluetooth.getAvailabilityAsync();
  //   if (!isAvailable) {
  //     return;
  //   }

  //   const options = {
  //     filters: [{ services: ['battery_service'] }],
  //   };

  //   try {
  //     const result = await Bluetooth.requestDeviceAsync(options);
  //     if (result.type === 'cancel') {
  //       return;
  //     }
  //     const { device } = result;

  //     console.log(`Bluetooth: Got device:`, device);
  //     if (device.gatt) {
  //       const server = await device.gatt.connect();
  //       console.log(`Bluetooth: Got server:`, server);
  //       const service = await server.getPrimaryService('battery_service');
  //       console.log(`Bluetooth: Got service:`, service);
  //       const characteristic = await service.getCharacteristic('battery_level');
  //       console.log(`Bluetooth: Got characteristic:`, characteristic);
  //       const value = await characteristic.readValue();
  //       console.log(`Bluetooth: Got value:`, value);
  //       const battery = value.getUint8(0);
  //       console.log(`Success: Got battery:`, battery);
  //     } else {
  //       // TODO: Bacon: Can we connect to the GATT or is that a no-op?
  //       console.error(`Error: connected device did not have a GATT`);
  //     }
  //   } catch ({ message }) {
  //     console.error(`Error: Couldn't get battery level: ${message}`);
  //   }
  // }

}

export default BluetoothService;